// src/components/ShortcutsHelp.jsx
//
// Modal con la lista de atajos de teclado. Se abre con `?` (ver Layout.jsx) o
// desde el menú de usuario del Topbar. La lista vive aquí para que haya una sola
// fuente de verdad; los atajos reales están en Layout, TicketList y TicketDetail.
import React from 'react';
import { Modal } from 'react-bootstrap';

export const GRUPOS_ATAJOS = [
    {
        titulo: 'En cualquier pantalla',
        atajos: [
            [['Ctrl', 'K'], 'Búsqueda global'],
            [['/'],         'Búsqueda global'],
            [['g', 't'],    'Ir a Tickets'],
            [['g', 'd'],    'Ir al Dashboard'],
            [['g', 'a'],    'Ir a Autorizaciones'],
            [['n'],         'Nuevo ticket'],
            [['?'],         'Mostrar esta ayuda'],
        ],
    },
    {
        titulo: 'Lista de tickets',
        atajos: [
            [['j'], 'Bajar al siguiente ticket'],
            [['k'], 'Subir al ticket anterior'],
            [['Enter'], 'Abrir el ticket seleccionado'],
            [['o'],     'Abrirlo en una pestaña nueva'],
            [['m'],     'Alternar "Solo míos"'],
            [['f'],     'Ir al buscador de la lista'],
            [['['],     'Página anterior'],
            [[']'],     'Página siguiente'],
        ],
    },
    {
        titulo: 'Detalle del ticket',
        atajos: [
            [['r'],                       'Ir al cuadro de respuesta'],
            [['Ctrl', 'Enter'],           'Enviar comentario'],
            [['Ctrl', 'Shift', 'Enter'],  'Enviar y cerrar ticket'],
            [['i'],                       'Nota interna sí / no'],
            [['a'],                       'Asignarme el ticket'],
            [['Esc'],                     'Salir del cuadro de texto / volver a la lista'],
        ],
    },
];

const kbdStyle = {
    display: 'inline-block',
    minWidth: 22,
    padding: '2px 7px',
    borderRadius: 6,
    border: '1px solid var(--c-border)',
    borderBottomWidth: 2,
    background: 'var(--c-input-bg)',
    color: 'var(--c-text-1)',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.3,
    textAlign: 'center',
};

function Teclas({ teclas }) {
    return (
        <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center', whiteSpace: 'nowrap' }}>
            {teclas.map((t, i) => (
                <React.Fragment key={i}>
                    <kbd style={kbdStyle}>{t}</kbd>
                    {i < teclas.length - 1 && teclas.length > 1 && t.length === 1 && teclas[i + 1].length === 1
                        ? <span style={{ fontSize: 11, color: 'var(--c-text-4)' }}>luego</span>
                        : null}
                </React.Fragment>
            ))}
        </span>
    );
}

export default function ShortcutsHelp({ show, onClose }) {
    return (
        <Modal show={show} onHide={onClose} centered size="lg">
            <Modal.Header closeButton style={{ borderBottom: '1px solid var(--c-border)' }}>
                <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>Atajos de teclado</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '18px 24px' }}>
                <p style={{ fontSize: 12, color: 'var(--c-text-3)', marginBottom: 14 }}>
                    Las teclas sueltas no actúan mientras escribes en un campo. Pulsa <kbd style={kbdStyle}>Esc</kbd> para salir del campo y volver a usarlas.
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '18px 28px' }}>
                    {GRUPOS_ATAJOS.map(g => (
                        <div key={g.titulo}>
                            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: .5, color: 'var(--c-text-3)', marginBottom: 8 }}>
                                {g.titulo}
                            </div>
                            {g.atajos.map(([teclas, desc], i) => (
                                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, padding: '5px 0', borderBottom: '1px solid var(--c-border)', fontSize: 13 }}>
                                    <span style={{ color: 'var(--c-text-2)' }}>{desc}</span>
                                    <Teclas teclas={teclas} />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    );
}
